import base from './base.js'
export default {
  ...base,
}
